<template>
    <nav id="sidebar" v-bind:class="isSidebarActive && 'isSidebarActive'" style="height: 125vh">
        <div class="p-4 w-72 mb-sm-16" id="sidebar2">
            <div id="site" class="d-none d-sm-block">
                <router-link
                    :to="$i18nHelper.getUrl('')"
                    @click.prevent class="logo"
                >
                    <div class="flex justify-around">
                        <div v-if="!isSidebarActive">
                            <img src="/images/Boshqar+logo.png" alt="" class="h-10">
                        </div>
                    </div>
                </router-link>
            </div>
            <ul class="list-unstyled">
                <!-- Links -->
                <li
                    class="active"
                    v-show="hasAvailableChildren(link.subLinks)"
                    v-for="(link, linkIndex) in links"
                    v-bind:key="linkIndex"
                >
                    <div v-if="!link.isIOS" class="arrow-left py-2">
                        <a
                            href="#"
                            @click.prevent="show(link)"
                            aria-expanded="true"
                            :class="isSidebarActive ? 'arrow-link h-11 pt-2 rounded' : 'arrow-link h-11 px-3 pt-2 rounded'"
                            :style="link.isVisible ? 'background-color: #7044bf; color: #fff' : ''"
                        >
                            <img :src="'/images/' + link.linkIcon" alt="home_logo" class="h-6 mr-1.5 mb-2.5">
                            <span class="close-name text-base">
                                 {{ $t(link.title) }}
                            </span>

                            <img v-if="link.isVisible" src="/images/arrow_down.png" class="h-2 mt-2.5 float-right" alt="down_arrow">
                            <img v-if="!link.isVisible && !isSidebarActive" src="/images/arrow_right.png" class="h-2 mt-2.5 float-right" alt="down_arrow">
                        </a>
                    </div>
                    <transition name="fade">
                        <ul
                            class="collapse list-unstyled"
                            :class="{show: link.isVisible}"
                            :id="'sidebar_' + linkIndex">
                            <li
                                v-for="(subLink, subLinkIndex) in link.subLinks"
                                v-bind:key="subLink.title"
                                v-show="subLink.hasAccess"
                            >
                                <router-link
                                    :disabled="subLink.url === 'sales/sale'"
                                    :event="subLink.url === 'sales/sale' ? '' : 'click'"
                                    :to="$i18nHelper.getUrl(subLink.url)"
                                    @click.native="goToSaleApp(subLink.url); link.isVisible = !link.isVisible"
                                    class="w-100 py-1"
                                    :class="isActiveLink(subLink) ? 'link-active' : ''"
                                    exact
                                >
                                    <div class="link text-wrap">
                                        <img v-if="(link.subLinks.length - 1) !== subLinkIndex" src="/images/Vector12.png" alt="" class="relative top-6 left-1 h-6">
                                        <img v-if="isActiveLink(subLink)" src="/images/Rectangle40.png" alt="" class="relative h-1.5">
                                        <img v-else src="/images/Rectangle37.png" alt="" class="relative top-0 h-1.5">
                                        <div :class="isSidebarActive ? 'inline-block w-40 rounded pl-3 py-2' : 'inline-block w-48 rounded pl-3 py-2'" :style="isActiveLink(subLink) ? 'background-color: #7044bf; color: #fff' : ''">
                                            {{ linkName(subLink.title) }}
                                            <img v-if="isActiveLink(subLink)" src="/images/arrow_right.png" class="h-2 mt-1.5 pr-2.5 float-right" alt="down_arrow">
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </transition>
                </li>
                <li>
                    <div
                        v-if="$store.getters.isAuthenticated"
                        class="cursor-pointer d-sm-none h-10"
                        @click="showModalInfo"
                    >
                        <div class=" h-10 px-1 arrow-left py-2">
                            <div class="text-white close-name text-base ml-2">
                                <img src="../assets/human-icon.png" width="25" height="25" alt="" class="mr-2">
                                {{ $t('profile') }}
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="closeSidebar">
            <a
                class="menu-toggle-wrap mb-lg-5 d-none d-lg-block gl-ml-3 js-toggle-sidebar qa-toggle-sidebar rspec-toggle-sidebar"
                role="button"
                title="Toggle sidebar"
                type="button"
                @click="toggleSidebar()"
            >
                <div class="d-flex justify-content-center mt-lg-5 fa-w-15x">
                    <div>
                        <svg
                            id="sidebarbutton"
                            style="margin-top: -2px"
                            xmlns="http://www.w3.org/2000/svg"
                            width="13"
                            height="13"
                            fill="currentColor"
                            class="bii bi-chevron-double-left"
                            viewBox="0 0 16 16"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M8.354 1.646a.5.5 0 0 1 0 .708L2.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                            />
                            <path
                                fill-rule="evenodd"
                                d="M12.354 1.646a.5.5 0 0 1 0 .708L6.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                            />
                        </svg>
                    </div>
                    <div>
                        <span class="sidebar-closename">{{ $t('collapseSidebar') }}</span>
                    </div>
                </div>
            </a>
        </div>
    </nav>
</template>

<script>
import {mapGetters} from "vuex";
import access from "@/mixin/functions/access";
import localStorageLang from "@/store/local/localStorageLang";
import localToken from "@/store/local/localToken";

export default {
    name: "Sidebar",
    computed: {
        ...mapGetters(['getUser', 'isAuthenticated']),
    },
    methods: {
        isActiveLink(subLink) {
            return this.$i18nHelper.getUrl(subLink.url) === this.$router.currentRoute ||
                this.isRouteNameExist(subLink)
        },
        isRouteNameExist(subLink) {
            return subLink.name.find(n => n === this.$route.name) !== undefined
        },
        showModalInfo() {
            this.$bvModal.show('user-info')
        },
        toggleSidebar() {
            this.isSidebarActive = !this.isSidebarActive
            this.$emit("isSidebarActive", this.isSidebarActive)
        },
        linkName(name) {
            switch (name) {
                case 'null':
                    return this.$t(name) + ' (' + this.$t('soon.title') + ')'

                default:
                    return this.$t(name)
            }
        },
        show(item) {
            if(item.title === this.section) {
                item.isVisible = !item.isVisible
            } else {
                for (let link of this.links) {
                    link.isVisible = false
                }

                this.section = item.title
                item.isVisible = true
            }
        },
        findByCategory(category) {
            for (let link of this.links) {
                if (link.category === category) {
                    return link
                }
            }

            return null
        },
        hasAvailableChildren(subLinks) {
            for (let subLink of subLinks) {
                if (subLink.hasAccess) {
                    return true
                }
            }

            return false
        },
        generateLinks() {
            return [
                {
                    title: "main",
                    category: 'home',
                    linkIcon: 'Home.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['home'],
                            subLinkIcon: 'home',
                            title: "home",
                            url: "",
                            hasAccess: true,
                        },
                        {
                            name: ['sales/newSale'],
                            subLinkIcon: 'shopping-cart',
                            title: "sale.title",
                            url: "sales/sale",
                            hasAccess: access.canSale()
                        },
                        {
                            name: ['products', 'products/page', 'products/view', 'products/history'],
                            subLinkIcon: 'shopping-bag',
                            title: "product.title",
                            url: "products",
                            hasAccess: this.isAuthenticated
                        },
                        {
                            name: ['warehouses/add', 'warehouse/show', 'warehouses/page', 'warehouses', 'warehouse'],
                            subLinkIcon: 'warehouse',
                            title: "warehouse.title",
                            url: "warehouses",
                            hasAccess: access.canStoreKeeping()
                        },
                        {
                            name: ['services'],
                            subLinkIcon: 'users-cog',
                            title: "service.title",
                            url: "services",
                            hasAccess: access.canManageServices()
                        },
                        {
                            name: ['company'],
                            subLinkIcon: 'landmark',
                            title: "company.title",
                            url: "company",
                            hasAccess: access.canSeeCompanyInfo()
                        },
                        // {
                        //     name: ['logout'],
                        //     subLinkIcon: 'sign-out-alt',
                        //     title: "login.logout",
                        //     url: "logout",
                        //     hasAccess: this.isAuthenticated
                        // },
                        {
                            name: ['login'],
                            subLinkIcon: 'sign-in-alt',
                            title: "login.title",
                            url: "login",
                            hasAccess: !this.isAuthenticated
                        },
                    ],
                },
                {
                    title: "statistics.title",
                    category: 'statistics',
                    linkIcon: 'Statistika_Icon.png',
                    isVisible: false,
                    subLinkIcon: 'shopping-cart',
                    subLinks: [
                        {
                            name: ['statistics/sale'],
                            subLinkIcon: 'chart-pie',
                            title: "statistics.sale",
                            url: "statistics/sales",
                            hasAccess: access.canSeeStatisticsInfo()
                        },
                        {
                            name: ['statistics/product', 'statistics/product/page',],
                            subLinkIcon: 'chart-bar',
                            title: "statistics.product",
                            url: "statistics/product",
                            hasAccess: access.canSeeStatisticsInfo()
                        },
                        {
                            name: ['statistics/product-dynamic'],
                            subLinkIcon: 'chart-bar',
                            title: "statistics.productDynamic",
                            url: "statistics/product-dynamic",
                            hasAccess: access.canSeeStatisticsInfo()
                        },
                        {
                            name: ['statistics/service', 'statistics/service/page'],
                            subLinkIcon: 'chart-bar',
                            title: "statistics.service",
                            url: "statistics/service",
                            hasAccess: access.canSeeStatisticsInfo()
                        },
                        // {
                        //     name: ['statistics/purchase'],
                        //     subLinkIcon: 'chart-area',
                        //     title: "statistics.purchase",
                        //     url: "statistics/purchase",
                        //     hasAccess: access.canSeeStatisticsInfo()
                        // },
                        {
                            name: ['statistics/employee'],
                            subLinkIcon: 'users',
                            title: "statistics.employeeStat",
                            url: "statistics/employee",
                            hasAccess: access.canSeeStatisticsInfo()
                        },
                        {
                            name: ['statistics/customer'],
                            subLinkIcon: 'user-friends',
                            title: "statistics.customer.title",
                            url: "statistics/customer",
                            hasAccess: access.canSeeStatisticsInfo()
                        },
                        // {
                        //     name:['statistics/supplier'],
                        //     subLinkIcon: 'users-cog',
                        //     title: "statistics.supplier",
                        //     url: "statistics/supplier",
                        //     hasAccess: access.canSeeStatisticsInfo()
                        // },
                    ]
                },
                {
                    title: "finance.title",
                    category: 'companyCount',
                    linkIcon: 'finans.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['companyCount', 'companyCounts', 'companyCount/add', 'companyCount/edit'],
                            subLinkIcon: 'landmark',
                            title: 'finance.counts',
                            url: "companyCount",
                            hasAccess: access.canSeeCompanyInfo()
                        },
                        {
                            name: ['incomeAndOutcomeCategory', 'incomeAndOutcomeCategories', 'incomeAndOutcomeCategory/add', 'incomeAndOutcomeCategory/edit'],
                            subLinkIcon: 'sliders-h',
                            title: "category",
                            url: "incomeAndOutcomeCategory",
                            hasAccess: access.canSeeCompanyInfo()
                        },
                        {
                            name: [
                                'incomeAndOutcome/edit',
                                'incomeAndOutcome',
                                'incomeAndOutcomes',
                                'incomeAndOutcome/add'
                            ],
                            subLinkIcon: 'donate',
                            title: 'transactions',
                            url: "incomeAndOutcome",
                            hasAccess: access.canSeeCompanyInfo()
                        },
                        {
                            name: ['report'],
                            subLinkIcon: 'donate',
                            title: 'finance.report',
                            url: "report",
                            hasAccess: access.canSeeCompanyInfo()
                        },
                    ]
                },
                {
                    title: "product.title",
                    category: 'products',
                    linkIcon: 'Maxsulot_Icon.png',
                    isVisible: false,
                    subLinkIcon: 'shopping-cart',
                    subLinks: [
                        {
                            name: ['products', 'products/page', 'products/view', 'products/history'],
                            subLinkIcon: 'shopping-bag',
                            title: "product.title",
                            url: "products",
                            hasAccess: this.isAuthenticated
                        },
                        {
                            name: [
                                'product-categories/add',
                                'product-categories/view',
                                'product-categories/page',
                                'product-categories'
                            ],
                            subLinkIcon: 'bars',
                            title: "category",
                            url: "product-categories",
                            hasAccess: access.canManageProducts()
                        },
                        {
                            name: ['products/purchase', 'products/purchase/warehouse'],
                            subLinkIcon: 'cart-plus',
                            title: "productPurchase.title",
                            url: "products/0/purchase",
                            hasAccess: access.canPurchaseProducts()
                        },
                        // {
                        //     subLinkIcon: 'cart-arrow-down',
                        //     title: "productPurchase.few",
                        //     url: "products/0/purchase-few",
                        //     hasAccess: access.canPurchaseProducts()
                        // },
                        {
                            name: [
                                'products/transactions/page',
                                'products/transaction/id',
                                'products/transactions'
                            ],
                            subLinkIcon: 'money-check-alt',
                            title: "transactions",
                            url: "products/transactions",
                            hasAccess: access.canSeeProductPurchasesHistory()
                        },
                        {
                            name: ['expiration-products'],
                            subLinkIcon: 'hourglass-end',
                            title: "product.productExpired",
                            url: "expiration-products",
                            hasAccess: access.canManageProducts()
                        },
                        {
                            name: ['import-excel', 'excel-error', 'imported-excel'],
                            subLinkIcon: 'file-import',
                            title: "excel.import",
                            url: "import-excel",
                            hasAccess: access.canPurchaseProducts()
                        },
                        {
                            name: ['export-barcode'],
                            subLinkIcon: 'file-export',
                            title: "export",
                            url: 'export-barcode',
                            hasAccess: access.canPurchaseProducts()
                        },
                        {
                            name: ['products/deleted', 'products/deleted/page'],
                            subLinkIcon: 'trash',
                            title: "trash",
                            url: "products/deleted",
                            hasAccess: access.canManageProducts()
                        },
                        {
                            name: ['auto-order',],
                            subLinkIcon: 'handshake',
                            title: "autoOrder.title",
                            url: "orders",
                            hasAccess: access.canAutoOrder()
                        },
                        {
                            name: ['scale',],
                            subLinkIcon: 'balance-scale',
                            title: "scale.title",
                            url: "scales",
                            hasAccess: access.canPurchaseProducts()
                        },
                        {
                            name: [
                                'product/modify',
                                'product/make-modify',
                                'product/modify/page',
                                'product/modified-products',
                            ],
                            subLinkIcon: 'hand-holding-usd',
                            title: "productPriceModify.title",
                            url: "product-modify",
                            hasAccess: access.canPurchaseProducts()
                        },
                    ]
                },
                {
                    title: "warehouse.title",
                    category: 'warehouses',
                    linkIcon: 'Ombor_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['warehouses/add', 'warehouse/show', 'warehouses/page', 'warehouses', 'warehouse'],
                            subLinkIcon: 'warehouse',
                            title: "warehouse.title",
                            url: "warehouses",
                            hasAccess: access.canStoreKeeping()
                        },
                        {
                            name: ['products-in-warehouses', 'products-in-warehouse', 'products-in-warehouses/page'],
                            subLinkIcon: 'boxes',
                            title: "productsInWarehouse.title",
                            url: "products-in-warehouses",
                            hasAccess: this.isAuthenticated
                        },
                        {
                            name: ['change-warehouses'],
                            subLinkIcon: 'truck',
                            title: "productsInWarehouse.changeWarehouse",
                            url: "change-warehouses",
                            hasAccess: access.canManageProducts()
                        },
                        {
                            name: ['write-off', 'expired-product-write-off'],
                            subLinkIcon: 'minus-circle',
                            title: "productsInWarehouse.writeOff",
                            url: "write-off",
                            hasAccess: access.canWriteOffProductInWarehouse()
                        },
                        {
                            name: ['products-in-warehouses-write-off', 'products-in-warehouse-write-off'],
                            subLinkIcon: 'store-alt-slash',
                            title: "productsInWarehouse.wroteOff",
                            url: "products-in-warehouses-write-off",
                            hasAccess: access.canWriteOffProductInWarehouse()
                        },
                        {
                            name: ['inventories', 'inventory'],
                            subLinkIcon: 'boxes',
                            title: "inventory.title",
                            url: "inventory",
                            hasAccess: access.canManageProducts()
                        },
                    ]
                },
                {
                    title: "service.title",
                    category: 'services',
                    linkIcon: 'Xizmat_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['services', 'services/add', 'services/edit', 'services/page'],
                            subLinkIcon: 'users-cog',
                            title: "service.title",
                            url: "services",
                            hasAccess: access.canManageServices()
                        },
                        {
                            name: ['services/transactions', 'services/transactions/page'],
                            subLinkIcon: 'money-check-alt',
                            title: "transactions",
                            url: "services/transactions",
                            hasAccess: access.canSeeSaleHistory()
                        },
                    ]
                },
                {
                    title: "sale.title",
                    category: 'sales',
                    linkIcon: 'Savdo_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['sales/edit', 'sales/newSale'],
                            subLinkIcon: 'shopping-cart',
                            title: "sale.title",
                            url: "sales/sale",
                            hasAccess: access.canSale()
                        },
                        {
                            name: ['sales/draftSales', 'sales/draftSales/page'],
                            subLinkIcon: 'cart-arrow-down',
                            title: "sale.draft",
                            url: "sales/drafts",
                            hasAccess: access.canSale()
                        },
                        {
                            name: ['sales/taxes', 'sales/taxes/add', 'sales/taxes/edit'],
                            subLinkIcon: 'donate',
                            title: "sale.tax.title",
                            url: "sales/taxes",
                            hasAccess: access.canManageTaxes()
                        },
                        {
                            name: ['sales/discounts/add', 'sales/discounts/edit', 'sales/discounts', 'sales/discounts/page'],
                            subLinkIcon: 'percentage',
                            title: "sale.discount.title",
                            url: "sales/discounts",
                            hasAccess: access.canManageDiscounts()
                        },
                        {
                            name: ['sales/transaction/print', 'sales/transaction/check', 'sales/transactions'],
                            subLinkIcon: 'money-check-alt',
                            title: "transactions",
                            url: "sales/transactions",
                            hasAccess: access.canSeeSaleHistory()
                        },
                        {
                            name: ['sales/orders'],
                            subLinkIcon: 'money-check-alt',
                            title: "order.onlineOrder",
                            url: "sales/orders",
                            hasAccess: access.canSeeSaleHistory()
                        },
                    ]
                },
                // {
                //     title: "production.title",
                //     linkIcon: 'Production.png',
                //     isVisible: false,
                //     subLinks: [
                //         {
                //             name: ['production', 'production/properties'],
                //             subLinkIcon: 'production',
                //             title: "production.properties.title",
                //             url: "production/properties",
                //             hasAccess: access.canSale()
                //         },
                //         {
                //             name: ['production', 'production/finishedProducts', 'production/finishedProducts/add'],
                //             subLinkIcon: 'production',
                //             title: "production.finishedProduct.title",
                //             url: "production/finishedProducts",
                //             hasAccess: access.canManageServices()
                //         },
                //         {
                //             name: ['sales/taxes', 'sales/taxes/add', 'sales/taxes/edit'],
                //             subLinkIcon: 'donate',
                //             title: "production.category.title",
                //             url: "#",
                //             hasAccess: access.canManageTaxes()
                //         },
                //         {
                //             name: ['sales/discounts/add', 'sales/discounts/edit', 'sales/discounts', 'sales/discounts/page'],
                //             subLinkIcon: 'percentage',
                //             title: "sale.discount.title",
                //             url: "#",
                //             hasAccess: access.canManageDiscounts()
                //         },
                //         {
                //             name: ['sales/transaction/print', 'sales/transaction/check', 'sales/transactions'],
                //             subLinkIcon: 'money-check-alt',
                //             title: "production.transactions.title",
                //             url: "#",
                //             hasAccess: access.canSeeSaleHistory()
                //         },
                //     ]
                // },
                {
                    title: "returnProducts.return",
                    category: 'return',
                    linkIcon: 'Return_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['saleRefund/Add', 'saleRefund/List', 'saleRefund/List/page', 'saleRefund'],
                            subLinkIcon: 'undo',
                            title: "returnProducts.returnCustomer",
                            url: "saleRefund",
                            hasAccess: access.canSale()
                        },
                        {
                            name: ['purchaseRefund/List', 'purchaseRefund/List/page', 'purchaseRefund', 'purchaseRefund/Add'],
                            subLinkIcon: 'truck-loading',
                            title: "returnProducts.returnSupplier",
                            url: "purchase-refund",
                            hasAccess: access.canSale()
                        },
                    ]
                },
                {
                    title: "customer.title",
                    category: 'customers',
                    linkIcon: 'Mijoz_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['customersId', 'customers/add', 'customers', 'customer', 'customers/edit'],
                            subLinkIcon: 'handshake',
                            title: "customer.title",
                            url: "customers",
                            hasAccess: access.canManageCustomers() || access.canSeeCustomerDebts()
                        },
                    ]
                },
                {
                    title: "supplier.title",
                    category: 'suppliers',
                    linkIcon: 'Delivery_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['suppliers/edit', 'suppliers/add', 'suppliersId', 'supplier', 'suppliers'],
                            subLinkIcon: 'dolly-flatbed',
                            title: "supplier.title",
                            url: "suppliers",
                            hasAccess: access.canManagerSuppliers() || access.canSeeSupplierDebts()
                        },
                    ]
                },
                {
                    title: "company.title",
                    category: 'company',
                    linkIcon: 'Company_Icon.png',
                    isVisible: false,
                    subLinks: [
                        {
                            name: ['company'],
                            subLinkIcon: 'landmark',
                            title: "company.title",
                            url: "company",
                            hasAccess: access.canSeeCompanyInfo()
                        },
                        {
                            name: ['employees', 'employees/page', 'employees/show', 'employees/add'],
                            subLinkIcon: 'user-tie',
                            title: "employee.title",
                            url: "employees",
                            hasAccess: access.canManageEmployees()
                        },
                        {
                            name: ['employees/kpi/add', 'employees/kpi', 'employees/kpi/list'],
                            subLinkIcon: 'user-tie',
                            title: "kpi.title",
                            url: "employees/kpi/list",
                            hasAccess: access.canManageKpis()
                        },
                        {
                            name: [
                                'employees/positions/show',
                                'employees/positions/add',
                                'employees/positions/page',
                                'employees/positions'
                            ],
                            subLinkIcon: 'chair',
                            title: "employee.position",
                            url: "employees/positions",
                            hasAccess: access.canManageEmployees()
                        },
                        {
                            name: ['currency-rate'],
                            subLinkIcon: 'dollar-sign',
                            title: "currencyRate.currencyRate",
                            url: "currency-rate/list",
                            hasAccess: access.canManageEmployees()
                        },
                    ]
                },
                {
                    title: "plan.title",
                    category: 'plans',
                    linkIcon: 'Price_Icon.png',
                    isVisible: false,
                    isIOS: true,
                    subLinks: [
                        {
                            name: ['plans/compare'],
                            subLinkIcon: 'tasks',
                            title: "plan.compare",
                            url: "plans/compare",
                            hasAccess: true
                        },
                    ]
                },
            ]
        },
        getBooleanFromLocalStorage(key) {
            const value = localStorage.getItem(key)

            if (value === null) {
                return true
            }

            return value === 'true'
        },
        checkRoute() {
            if (this.$route.meta['category'] === undefined) {
                return
            }

            let item = this.findByCategory(this.$route.meta.category)

            if (item !== null) {
                this.show(item)
            }
        },
        setCookie(name, value, days) {
            let expires = ''

            if (days) {
                const date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = "; expires=" + date.toUTCString();
            }

            let domain = ''

            if (process.env.NODE_ENV === 'production') {
                domain = 'domain=.boshqar.com'
            }

            document.cookie = name + "=" + (value || "") + expires + `; path=/; ${domain}`;
        },
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        },
        goToSaleApp(url) {
            if (!this.getCookie('access')) {
                this.setCookie('access', localToken.getAccess(), 7)
                this.setCookie('refresh', localToken.getRefresh(), 7)
                this.setCookie('lang', localStorageLang.get(), 7)

            }

            if (url !== 'sales/sale') {
                this.$i18nHelper.getUrl(url)

                return
            }

            switch (process.env.VUE_APP_BRANCH) {
                case 'master':
                    window.open(`${process.env.VUE_APP_SALE_MASTER_URL}/${localStorageLang.get()}`, '_blank');
                    break
                case 'dev':
                    window.open(`${process.env.VUE_APP_SALE_DEV_URL}/${localStorageLang.get()}`, '_blank');
                    break
                case 'local':
                    window.open(`${process.env.VUE_APP_SALE_LOCAL_URL}/${localStorageLang.get()}`, '_blank');
                    break
            }
        }
    },
    watch: {
        '$route.meta': function () {
            this.checkRoute()
        },
        '$store.getters.getUserRoles': function () {
            this.links = this.generateLinks()
            this.checkRoute()
        },
        '$store.getters.getAccessToken': function () {
            this.links = this.generateLinks()
            this.checkRoute()
        }
    },
    data() {
        return {
            appName: process.env.VUE_APP_NAME,
            links: this.generateLinks(),
            isSidebarActive: false,
            newSection: '',
            section: ''
        }
    },
    mounted() {
        this.checkRoute()

        setTimeout(() => this.links = this.generateLinks(), 2000)
    }
}
</script>

<style scoped>

body {
}

.link-active {
    color: #fbff55 !important;
}

#sidebar {
    height: 100%;
    min-height: 107vh;
    max-width: 300px;
    background: #6539B2;
    -webkit-transition: all .3s;
    -o-transition: all .3s;
    transition: all 0.3s;
    position: relative;
}

#sidebar2 {
    height: 100%;
    overflow-y: scroll !important;
}

#sidebar2::-webkit-scrollbar {
    width: 0 !important;
}

#sidebarbutton {
    margin-right: 4px;
}

.sidebar-closename {
    margin-right: 15px;
}

.isSidebarActive {
    height: 100%;
    position: absolute;
    width: 60px;
    transition: margin 0.8s ease-in;
}

.isSidebarActive .arrow-left a {
    width: 50px;
    text-decoration: none;
}

.arrow-link {
    //padding: 100px 150px;
    text-decoration: none;
}

.boshqar-logo {
    width: 1.7rem;
    opacity: 0;
}

.isSidebarActive .boshqar-logo {
    opacity: 1;
    top: 1em;
    position: absolute;
    text-align: left;
    margin-left: -0.5rem;
}

.menu-toggle-wrap {
    position: absolute;
    margin: 3px;
    border-radius: 5px;
    width: 220px;
    height: 4%;
    bottom: -2.7em;
}

.menu-toggle-wrap:hover {
    background: #9d68ff;
}

.d-flex {
    position: absolute;
    bottom: 0.5em;
    margin-left: 35px;
    color: #FFFFFF;
    font-size: 16px;
}

.isSidebarActive .menu-toggle-wrap {
    width: 55px;
    color: #FFFFFF;
    margin-left: 4%;
}

.isSidebarActive .menu-toggle-wrap #sidebarbutton {
    transform: rotate(180deg);
    transition: 0.3s ease;
    margin-left: -15px;
}

.isSidebarActive .icon-link {
    font-size: 18px;
}

.isSidebarActive .arrow-left a {
    width: 50px;
}

.isSidebarActive .list-unstyled .active {
    margin-left: -0.4rem;
}

.isSidebarActive .active {
    left: 2rem;
}

.isSidebarActive .sidebar-closename {
    display: none;
}

.close-name {
    //text-transform: uppercase;
    font-weight: bold;
}

.isSidebarActive .close-name {
    display: none;
    opacity: 0;
    pointer-events: auto;
}

.isSidebarActive .logo-name {
    opacity: 0;
    pointer-events: none;
}

#company-name {
    color: white;
    font-style: italic;
}

.isSidebarActive #down-icon {
    position: absolute;
    display: none;
}

.isSidebarActive .list-unstyled {
    display: block;
}

.isSidebarActive li:nth-child(1):hover .collapse {
    display: block;
}

.isSidebarActive li:nth-child(2):hover .collapse {
    display: block;
}

.isSidebarActive li:nth-child(3):hover .collapse {
    display: block;
}

.isSidebarActive li:nth-child(4):hover .collapse {
    display: block;
}

.isSidebarActive li:nth-child(5):hover .collapse {
    display: block;
}

.isSidebarActive li:nth-child(6):hover .collapse {
    display: block;
}

.isSidebarActive li:nth-child(7):hover .collapse {
    display: block;
}

.isSidebarActive .collapse {
    position: absolute;
    list-style-type: none;
    display: none;
    z-index: 1;
    background-color: #6f42c1;
    color: #FFFFFF;
    border-radius: 10px;
    text-align: left;
    width: 190px;
    margin-top: -2.65em;
    transform: translateX(19%);
    cursor: initial;
}

.isSidebarActive .collapse .link {
    position: relative;
    margin-left: 7%;
    transition: opacity 0.3s ease;
}

.isSidebarActive .collapse {
    box-shadow: 20px 20px 20px rgb(0, 0, 0, .2);
    transition: opacity 0.5s ease;
}

.isSidebarActive .link:hover {
    margin-left: 1rem;
}

#sidebar #site {
    margin-bottom: 20px;
    font-size: 25px;
    font-weight: 700;
    text-decoration: none;
    z-index: auto;
}

#sidebar #site a:hover {
    text-decoration: none;
}

#sidebar #site .logo {
    color: #fff
}

#sidebar ul.components {
    padding: 0
}

#sidebar ul li {
    font-size: 16px;
    transition: all .3s;
}

#sidebar ul li > ul {
    margin-left: 10px;
    transition: all .3s;
}

#sidebar ul li > ul li {
    transition: all .3s;
    font-size: 14px;
}

#sidebar ul li a {
    padding: 10px 0;
    display: block;
    color: #fff;
    //border-bottom: 1px solid rgba(255, 255, 255, .1);
    text-decoration: none;
}

#sidebar ul li a:hover {
    color: #fff
}

#sidebar ul li.active > a {
    background: 0 0;
    color: #fff;
    text-transform: uppercase;
    font-weight: bold;
}

#sidebar .custom-menu .btn {
    width: 40px;
    height: 40px;
    border-radius: 50%
}

#sidebar .custom-menu .btn.btn-primary {
    background: #6749b9;
    border-color: #6749b9
}

#sidebar .custom-menu .btn.btn-primary:hover, #sidebar .custom-menu .btn.btn-primary:focus {
    background: #6749b9 !important;
    border-color: #6749b9 !important
}

</style>